<template>
  <div class="container">
    <!-- <div class="header">
      <div class="title1">大厂内推</div>
      <div class="title2">推荐</div>
      <div class="title2">面经</div>
      <div class="title2">探厂</div>
    </div> -->
    <div class="header-bg">
      <div class="share-icon" @click="shareFn"></div>
      <div class="tabs-wrap">
        <div :class="{
          'tab-item': true,
          'actived': tabActived == tab
        }" v-for="(tab, index) in tabs"
        :key="index"
        @click="changeTab(tab)"
        >{{ tab }}</div>
      </div>
    </div>

    <div class="list-wrap">
      <div
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="banner-box" @click="openWeapp(item.type, item.btnName, item.courseId)">
          <div class="banner-content">
            <div class="banner-title">【{{ txtMap[item.type] }}】极速内推群</div>
          </div>
        </div>
        <div :class="{
          'list-item': true
        }"
        >
          <div :class="{
            'list-tab': true,
            'list-tab-long': item.type == 4
          }">{{ item.tips }}</div>
          <div :class="{
            'list-item-header': true
          }">
            <img class="header-img" :src="item.classImgUrl">
          </div>
          <div class="list-item-card">
            <div class="card-header">
              <div class="card-img-wrap">
                <img class="card-img" :src="item.companyImg">
              </div>
              <div class="card-company">
                <div class="company-name">
                  {{ item.companyName }}
                  <!-- <div v-if="item.type !== 3 && item.type !== 4 && item.type !== 5" class="new-timer">
                    <div class="green-icon"></div>
                    <div>{{ item.time }}</div>
                  </div> -->
                </div>
                <div class="company-labels" v-for="(label, i) in item.labels" :key="i">
                  <div class="label">{{ label }}</div>
                </div>
              </div>
            </div>
            <div class="card-btn-wrap">
              <div :class="{
                'card-btn-left': true,
                'middle': true
              }">
                <div class="red-icon"></div>
                <div class="btn-time">{{ item.time }}</div>
              </div>
              <div
                :class="{
                  'card-btn': true,
                  'small': true
                }"
              @click="openWeapp(item.type, item.btnName, item.courseId)">{{ item.btnName }} <div class="white-icon"></div> </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-wrap">
      <div class="more-content" @click="openWeapp(6, '其他', 1477)">
        <div class="more-swiper">
          <img v-for="(img, index) in companyImgs"
          :key="index"
          :src="img"
          :class="['company-item', `left${index}`]"
          />
        </div>
        <div class="more-right">
          <div>不合心意？还有这些好公司等你</div>
          <div class="more-icon"></div>
        </div>
      </div>
    </div>
    <div class="footer-logo"></div>
    <div v-if="showModal" class="modal-container">
      <div class="modal">
        <div class="modal-close" @click="showModal = false"></div>
        <div class="modal-desc">长按识别下方二维码，添加小助手</div>
        <div class="modal-desc">获取直播地址和提醒</div>
        <img class="qrCode" :src="qrCodeUrl" />
        <!-- <div v-if="isAndroid" class="modal-btn" @click="savePic">保存二维码</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import list from './data'
import { getExpectedPosition, appointmentPublicCourse } from '../../../service/api';
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
import * as Cookies from 'js-cookie';
export default {
  name: "InterviewCardH5",
  data() {
    return {
      list,
      page_id:'n1tia',
      tabs: [ '测试', '产品', '研发', '数据分析', '运营' ],
      tabActived: '研发',
      dataList: [],
      isAndroid: navigator.userAgent.indexOf('Android') !== -1,
      companyImgs: [
        "//www.lgstatic.com/thumbnail_160x160/i/image/M00/49/E7/Ciqc1F9QZJSAC0VBAACwLdjC9yo459.png",
        "//www.lgstatic.com/thumbnail_160x160/i/image2/M01/03/84/CgpVE1_ch26AEM8AAAAxNiZmyCE990.png",
        "//www.lgstatic.com/thumbnail_160x160/i/image/M00/67/04/CgpEMlmepHiAJmEXAAArAJs2qv0103.jpg",
        "//www.lgstatic.com/thumbnail_160x160/i/image2/M00/13/95/CgotOVnwNqeAFbmnAABaH5Q_vVE401.png",
      ],
      qrCodeUrl: "",
      qrCodeImg: [
        // 测试
        'https://s20.lgstatic.com/growth/activity/20220214/1644832255654.png',
        // 产品
        'https://s21.lgstatic.com/growth/activity/20220214/1644832266988.png',
        // 前端
        'https://s20.lgstatic.com/growth/activity/20220214/1644832277965.png',
        // JAVA
        'https://s21.lgstatic.com/growth/activity/20220214/1644832290731.png',
        // 数据分析
        'https://s21.lgstatic.com/growth/activity/20220214/1644832309988.png',
        // 运营
        'https://s20.lgstatic.com/growth/activity/20220214/1644832322180.png',
        // 综合
        'https://s21.lgstatic.com/growth/activity/20220214/1644832332303.png'
      ],
      showModal: false,
      txtMap: {
        0: '测试',
        1: '产品',
        // 2: '前端',
        // 3: 'Java',
        3: '研发',
        4: '数分',
        5: '运营',
      }
    };
  },
  mounted() {
    this.eduPlatTrack('WebView', {
      page_id: this.page_id
    });
    if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token') || this.isApp) {
      getExpectedPosition().then(res => {
        if (res.state == 1) {
          this.tabActived = res.content || "研发";
          this.filterDataList(this.tabActived);
          this.filterTabsList(this.tabActived);
        } else {
          this.filterDataList(this.tabActived);
        }
      }).catch(() => {
        this.filterDataList(this.tabActived);
      })
    } else {
      this.filterDataList(this.tabActived);
    }
    this.loop()
  },
  methods: {
    shareFn() {
      if (this.isAndroid) {
        window.location = `lagou://lagou.com/share?url=${window.location.href}&title=拉勾求职帮帮团，帮你内推“走后门”！&desc=求职问题一站搞定&icon=https://s20.lgstatic.com/growth/activity/20220215/1644912610561.png`
        return;
      }
      window.lgBridge && window.lgBridge.request('share', {
        data: {
          type: 'link',
          channel: 'wechat_friends',
          options: {
            url: window.location.href,
            desc: '求职问题一站搞定',
            title: '拉勾求职帮帮团，帮你内推“走后门”！',
            thumb: 'https://s20.lgstatic.com/growth/activity/20220215/1644912610561.png'
          }
        },
      }, (res) => {
        let { data = {} } = res;
        if (data.state === 1) {
            this.showToast('未安装微信');
        }
      });
    },
    savePic() {
      if (window.lgBridge) {
        window.lgBridge.request('saveUrlPicture', {
          data: {
            imageUrl: this.qrCodeUrl,
            isShowToast: true
          }
        });
      }
    },
    loop() {
      const items = document.getElementsByClassName('company-item');
      const len = items.length;
      for(let i = 0; i < len; i++) {
        if (i != len - 1) {
          items[i].style.transition = 'all linear .5s';
          items[i].style.transform = `translateX(0.413rem)`;
        } else {
          items[i].style.transform = `translateX(-1.254rem)`;
          items[i].style.zIndex = 0
        }
      }
      this.resultList()
    },
    resultList() {
      const recordList = JSON.parse(JSON.stringify(this.companyImgs))
      const last = recordList.pop();
      recordList.unshift(last);
      this.companyImgs = recordList;
      setTimeout(() => {
        this.loop()
      }, 3000)
    },
    changeTab(tab) {
      this.eduPlatTrack('WebButtonClick', {
        page_id: this.page_id,
        'button_name': tab
      });
      this.tabActived = tab;
      this.dataList = [];
      this.filterDataList(tab);
    },
    filterDataList(tab) {
      this.list.forEach(item => {
        if (item.class == tab) {
          this.dataList.push(item)
        }
      })
    },
    filterTabsList(tab) {
      const index = this.tabs.indexOf(tab);
      const recordTab = this.tabs[2];
      this.tabs[2] = tab;
      this.tabs[index] = recordTab;
    },
    openWeapp(type, btnName, courseId) {
      this.eduPlatTrack('WebButtonClick', {
        page_id: this.page_id,
        'button_name': btnName
      });
      if (!this.isApp) {
        if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
          return window.open('/frontLogin.do', '_self');
        }
        appointmentPublicCourse({ courseId }).then(res => {
          if (res.state == 1) {
            this.qrCodeUrl = this.qrCodeImg[type];
            this.showModal = true;
          }
        })
        return;
      }
      appointmentPublicCourse({ courseId }).then(res => {
        if (res.state == 1) {
          this.openWeappFn(type);
        }
      })
    },
    openWeappFn(type) {
      /**
       * from
       *    测试: 0   产品: 1   前端: 2   JAVA: 3   数分: 4   运营: 5   综合: 6
       * miniProgramType
       *    IOS: 1 小程序正式版  2 开发版  3 体验版
       *    安卓: 0 小程序正式版  1 开发版  2 体验版
       */
      const path = `/pages/interpolate/index.html?from=${type}`;
      const userName = 'gh_5bc6c955d1db';
      const miniProgramType = this.isAndroid ? 0 : 1;
      const locationPath = encodeURIComponent(path);
      if (this.isEduApp) {
        const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
        const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
        const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
        window.location = bridgeUrl;
      } else if (this.isLgApp) {
        const lgBridgeTitle = this.isAndroid ? 'lgeduapp' : 'lagou';
        const lgPath = this.isAndroid ? path : locationPath;
        const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
        window.location = lgBridgeUrl;
        // 兼容非首页安卓打开小程序
        if (this.isAndroid) {
          window.location = `lagouapp://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
        }
      }
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 890px;
  overflow-y: auto;
  background-color: #36CFA0;
}
.header {
  display: flex;
  height: 143px;
  color: #fff;
  padding: 60px 0 24px 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #fff;
}
.title1 {
  height: 60px;
  font-size: 40px;
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  font-weight: 500;
  line-height: 60px;
  margin-right: 64px;
}
.title2 {
  height: 45px;
  font-size: 30px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  margin-right: 37px;
  margin-top: 11px;
}
.header-bg {
  position: relative;
  width: 100%;
  height: 585px;
  background: url('https://s20.lgstatic.com/growth/activity/20220424/1650783573882.png') no-repeat center;
  background-size: 100% 585px;
  .share-icon {
    position: absolute;
    top: 12px;
    right: 24px;
    width: 44px;
    height: 44px;
    background: url('https://s21.lgstatic.com/growth/activity/20220215/1644927590970.png') no-repeat center;
    background-size: 44px 44px;
  }
  .tabs-wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 82px;
    padding: 17px 40px;
    box-sizing: border-box;
    justify-content: space-between;
    .tab-item {
      height: 48px;
      line-height: 46px;
      color: #fff;
      font-size: 26px;
      border: 1px solid #1C1D68;
      border-radius: 4px;
      text-align: center;
      padding: 0 24px;
      box-sizing: border-box;
      background-color: #2F41EC;
      &.actived {
        color: #2B236F;
        font-weight: bold;
        background-color: #FFE56F;
      }
    }
  }
}
.banner-box {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 22px;
  .banner-content {
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 11px;
    background-color: #fff;
    background: url("https://s21.lgstatic.com/growth/activity/20220217/1645099480828.png") no-repeat center;
    background-size: 100% 180px;
    .banner-title {
      position: absolute;
      top: 40px;
      left: 165px;
      font-size: 30px;
      font-family: SourceHanSansSC-Bold, SourceHanSansSC;
      font-weight: bold;
      color: #23312A;
    }
  }
}
.list-wrap {
  width: 100%;
  padding: 21px 40px 0;
  box-sizing: border-box;
  .list-item {
    position: relative;
    width: 100%;
    height: 604px;
    margin-bottom: 30px;
    &.more {
      height: 722px;
    }
    .list-tab {
      position: absolute;
      top: 26px;
      left: -7px;
      width: 186px;
      height: 50px;
      line-height: 50px;
      background: url('../assets/img/h5/tab_icon.png') no-repeat center;
      background-size: 186px 50px;
      padding-left: 59px;
      box-sizing: border-box;
      font-size: 25px;
      color: #fff;
      &-long {
        width: 230px;
        height: 50px;
        line-height: 50px;
        background: url('../assets/img/h5/tab_icon_long.png') no-repeat center;
        background-size: 230px 50px;
      }
    }
    .list-item-header {
      width: 100%;
      height: 356px;
      &.more {
        height: 474px;
      }
      .header-img {
        width: 100%;
        height: 100%;
        border-radius: 8px 8px 0 0;
      }
    }
    .list-item-card {
      position: relative;
      top: -22px;
      width: 100%;
      height: 256px;
      background-color: #fff;
      border-radius: 8px;
      padding: 28px 30px 33px 24px;
      box-sizing: border-box;
      .card-header {
        display: flex;
        width: 100%;
        .card-img-wrap {
          flex-shrink: 0;
          width: 107px;
          height: 107px;
          margin-right: 21px;
          .card-img {
            width: 107px;
            height: 107px;
            border: 1px solid #CECDDB;
            border-radius: 4px;
            box-sizing: border-box;
          }
        }
        .card-company {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .company-name {
            display: flex;
            width: 100%;
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1B1B1B;
            line-height: 45px;
            .new-timer {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 284px;
              height: 37px;
              line-height: 37px;
              border-radius: 19px;
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #4CBBAD;
              background-color: #E3FDF8;
              margin-left: 10px;
              .green-icon {
                width: 24px;
                height: 26px;
                background: url('https://s21.lgstatic.com/growth/activity/20220217/1645099319829.png') no-repeat center;
                background-size: 24px 26px;
                margin-right: 4px;
              }
            }
          }
          .company-labels {
            margin-top: 14px;
            display: flex;
            .label {
              height: 42px;
              line-height: 42px;
              text-align: center;
              background-color: rgba(211, 98, 59, .1);
              color: #CC754F;
              font-size: 22px;
              padding: 0 12px;
              border-radius: 4px;
              margin-right: 10px;
            }
          }
        }
      }
      .card-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 68px;
        border-radius: 34px;
        border: 2px solid #EF4934;
        box-sizing: border-box;
        margin-top: 20px;
        .card-btn-left {
          display: flex;
          align-items: center;
          &.middle {
            width: 310px;
            justify-content: center;
          }
          .red-icon {
            width: 28px;
            height: 30px;
            background: url('../assets/img/h5/clock_icon.png') no-repeat center;
            background-size: 28px 30px;
            margin-left: 26px;
          }
          .btn-time {
            font-size: 26px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #EF4934;
            margin-left: 14px;
          }
        }
        .card-btn {
          display: flex;
          width: 100%;
          height: 64px;
          line-height: 64px;
          background-color: #EF4934;
          border-radius: 32px;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          .white-icon {
            width: 24px;
            height: 26px;
            background: url('../assets/img/h5/white_btn_icon.png') no-repeat center;
            background-size: 24px 26px;
            margin-left: 11px;
          }
          &.small {
            width: 305px;
          }
        }
      }
    }
  }
}
.more-wrap {
  width: 100%;
  height: 92px;
  padding: 0 40px;
  box-sizing: border-box;
  .more-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 92px;
    line-height: 92px;
    background-color: #FFE56F;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #626776;
    padding: 0 46px 0 46px;
    box-sizing: border-box;
    border-radius: 8px;
    .more-swiper {
      // position: relative;
      width: 140px;
      display: flex;
      flex-wrap: nowrap;
      transition: all linear .5s;
      .more-swiper-wrapper {
        width: 140px;
        display: flex;
        flex-wrap: nowrap;
      }
      .company-item {
        display: flex;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        transition: all linear .5s;
        &.left0 {
          margin-left: 0;
          z-index: 1;
        }
        &.left1 {
          margin-left: -15px;
          z-index: 2;
        }
        &.left2 {
          margin-left: -15px;
          z-index: 3;
        }
        &.left3 {
          margin-left: -15px;
          z-index: 4;
        }
      }
    }
    .more-right {
      display: flex;
      align-items: center;
      .more-icon {
        width: 24px;
        height: 25px;
        background: url('../assets/img/h5/black_ben_icon.png') no-repeat center;
        background-size: 24px 25px;
        margin-left: 8px;
      }
    }
  }
}
.footer-logo {
  width: 100%;
  height: 150px;
  background: url('../assets/img/h5/logo.png') no-repeat center;
  background-size: 93px 46px;
}
/deep/ .swiper-slide {
  width: 0.613rem !important;
  height: 0.613rem;
}
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;
    .modal-header {
      display: flex;
      width: 180px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      justify-content: space-between;
      align-items: center;
      .modal-header-img {
        width: 40px;
        height: 40px;
      }
    }
    .modal-desc {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
    }
    .qrCode {
      display: block;
      width: 350px;
      height: 350px;
      margin: 49px auto 0;
    }
    .modal-btn {
      height: 88px;
      line-height: 88px;
      background: #00B38A;
      border-radius: 4px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      margin-top: 42px;
    }
    .modal-close {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      bottom: -130px;
      border-radius: 50%;
      z-index: 10000;
      background: url("../assets/img/h5/icon_delect@2x.png") no-repeat center;
      background-size: 100%;
      transform: translateX(-50%);
    }
  }
}
</style>
